import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ModalContext } from '@/utils/contexts/ModalContext';

const ModalText = () => {
	const { dict } = useSelector((state) => state.app);
	// const history = useHistory();
	// const { closeModal, setModalAdditionalInfo } = useContext(ModalContext);
	const { closeModal } = useContext(ModalContext);

	return (
		<div className={ 'modal__content modal__content--text' } >
			<div className={ 'modal__content--header' }>
				<h3 className={ 'modal__content--header-title' }>{dict.letter.popover.preview}</h3>

				<button className={ `modal__content--header-close` }
					onClick={
						closeModal
					}>
					<i className={ `icon-close icon` } />
				</button>
			</div>
			<div className={ 'modal__text' }>
				{dict.letter.popover.previewText}
			</div>
		</div>
	);
};

export default ModalText;